import { useCallback } from 'react';
import { faAdd } from '@fortawesome/free-solid-svg-icons';
import { Map } from 'immutable';
import { alpha } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Button } from 'components/button';
import { TextInput, DatePicker, DropDownInput } from 'components/input';
import plur from 'plur';
import PropTypes from 'prop-types';
import styles from './Table.module.scss';
import Grid from '@mui/material/Grid2';

function TableToolbar({ ref, modelName, numSelected, filters, filtersInfo, onCreate, onChangeFilter }) {
  const renderFilterInput = useCallback((filter, index) => {
    let body = null;
    switch (filter.type) {
      case 'text':
        body = (
          <TextInput
            key={index}
            name={filter.name}
            label={filter.label}
            value={filters.get(filter.name)}
            onChange={(e) => onChangeFilter(filter.name, e.target.value)}
          />
        );
        break;
      case 'date':
        body = (
          <DatePicker
            key={index}
            name={filter.name}
            label={filter.label}
            value={filters.get(filter.name)}
            onChange={(value) => onChangeFilter(filter.name, value)}
          />
        );
        break;
      case 'select':
      default:
        body = (
          <DropDownInput
            key={index}
            name={filter.name}
            label={filter.label}
            options={filter.options}
            value={filters.get(filter.name)}
            onChange={(e) => onChangeFilter(filter.name, e.target.value)}
          />
        );
    }

    return (
      <Grid item sx={{ width: '300px' }}>
        {body}
      </Grid>
    );
  }, [filters, onChangeFilter]);

  return (
    <Toolbar
      ref={ref}
      sx={[
        {
          pl: { xs: 2 },
          pr: { xs: 2 },
        },
        numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        },
      ]}
      classes={{
        root: styles.headerToolbar
      }}
    >
      <Grid container style={{ width: '100%' }} spacing={2} justifyContent='space-between' alignItems='center'>
        <Grid>
          <Stack
            direction='row'
            spacing={1}
            justifyContent='flex-start'
            alignItems='center'
          >
            {
              numSelected > 0 && (
                <Typography>
                  Selected {numSelected}{' '}
                  {modelName ? (numSelected === 1 ? modelName : plur(modelName)).replace(/([A-Z])/g, ' $1').trim() : (numSelected === 1 ? 'Item' : 'Items')}
                </Typography>
              )
            }

            {
              filtersInfo && filtersInfo.data && filtersInfo.data.length > 0 && (
                <Grid container direction='row' spacing={2} alignItems='center'>
                  <Grid item>
                    <Typography variant='h6'>Filter</Typography>
                  </Grid>
                  {filtersInfo.data.map(renderFilterInput)}
                </Grid>
              )
            }
            {/* <Button
              size='small'
              label='Sort'
              leading={faSort}
              variant='outlined'
            >
              <Chip label='2' size='small' />
            </Button> */}
            {/* <Button
              size='small'
              label='Filter'
              leading={faFilter}
              variant='outlined'
            /> */}
          </Stack>
        </Grid>
        <Grid>
          {numSelected > 0 ? (
            <Stack direction='row' spacing={1} justifyContent='flex-end'>
              {/* <IconButton
                icon={faEdit}
                tooltip='Edit'
                size='small'
                color='primary'
              />
              <IconButton
                icon={faPaste}
                tooltip='Duplicate'
                size='small'
                color='primary'
              />
              <IconButton
                icon={faTrashAlt}
                tooltip='Delete'
                size='small'
                color='error'
              /> */}
            </Stack>
          ) : (
            <>
              {!!onCreate && (
                <Button
                  size='small'
                  variant='outlined'
                  leading={faAdd}
                  label='Create'
                  onClick={onCreate}
                />
              )}
            </>
          )}
        </Grid>
      </Grid>
    </Toolbar>
  );
}

TableToolbar.propTypes = {
  ref: PropTypes.object,
  modelName: PropTypes.string,
  numSelected: PropTypes.number.isRequired,
  filters: PropTypes.instanceOf(Map),
  filtersInfo: PropTypes.object,
  onCreate: PropTypes.func.isRequired,
  onChangeFilter: PropTypes.func,
};

export default TableToolbar;
